// extracted by mini-css-extract-plugin
module.exports = {"container":"Navbar_container__UB5Ik","title":"Navbar_title__4ph7a"};